import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ArticleEditor = lazy(() => import('./articleEditor'));
const VersionHistory = lazy(() => import('./versionHistory/versionHistory'));
const CollectionRootPage = lazy(() => import('./collection/pages/home'));
const CollectionEditPage = lazy(
  () => import('./collection/pages/collectionEdit'),
);

export const getArticleEditorRoutes = (): RouteObject[] => [
  {
    path: `/article-editor/:articleId/version-history`,
    element: <VersionHistory />,
  },
  {
    // path: articleEditPath.pattern,
    //                         ^?
    path: `/article-editor/:articleId`,
    element: <ArticleEditor />,
  },
];

/** @deprecated Because we render nested routes as JSX */
export const CollectionRoutes: RouteObject[] = [
  {
    path: `/collection/:collectionId`,
    // path: collectionEditPath.pattern,
    //                         ^?
    element: <CollectionEditPage />,
  },
  {
    path: '/collection',
    // path: collectionRootPath.pattern,
    //                         ^?
    //             ^?
    element: <CollectionRootPage />,
    // exact: true,
  },
  // {
  //   path: '/articles',
  //   element: <ArticlesPage />,
  // },
];
